"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * price
     */
    DefaultApi.prototype.apiPriceGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.productId === null || requestParameters.productId === undefined) {
                            throw new runtime.RequiredError('productId', 'Required parameter requestParameters.productId was null or undefined when calling apiPriceGet.');
                        }
                        queryParameters = {};
                        if (requestParameters.productId !== undefined) {
                            queryParameters['product_id'] = requestParameters.productId;
                        }
                        if (requestParameters.colorCountsFront !== undefined) {
                            queryParameters['color_counts[front]'] = requestParameters.colorCountsFront;
                        }
                        if (requestParameters.colorCountsBack !== undefined) {
                            queryParameters['color_counts[back]'] = requestParameters.colorCountsBack;
                        }
                        if (requestParameters.colorCountsSleeve !== undefined) {
                            queryParameters['color_counts[sleeve]'] = requestParameters.colorCountsSleeve;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/price/",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ApiPriceGet200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * price
     */
    DefaultApi.prototype.apiPriceGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiPriceGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * store listings
     */
    DefaultApi.prototype.apiStoresGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.owner !== undefined) {
                            queryParameters['owner'] = requestParameters.owner;
                        }
                        if (requestParameters.offeringType !== undefined) {
                            queryParameters['offering_type'] = requestParameters.offeringType;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (requestParameters.xCustominkUid !== undefined && requestParameters.xCustominkUid !== null) {
                            headerParameters['X-Customink-Uid'] = String(requestParameters.xCustominkUid);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ApiStoresGet200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * store listings
     */
    DefaultApi.prototype.apiStoresGet = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create store
     */
    DefaultApi.prototype.apiStoresPostRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ApiStoresPostRequestToJSON)(requestParameters.apiStoresPostRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * create store
     */
    DefaultApi.prototype.apiStoresPost = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresPostRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * analytics
     */
    DefaultApi.prototype.apiStoresUrlSlugAnalyticsDataGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugAnalyticsDataGet.');
                        }
                        queryParameters = {};
                        if (requestParameters.dateStart !== undefined) {
                            queryParameters['date_start'] = requestParameters.dateStart;
                        }
                        if (requestParameters.dateEnd !== undefined) {
                            queryParameters['date_end'] = requestParameters.dateEnd;
                        }
                        if (requestParameters.bucketSize !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucketSize;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (requestParameters.xCustominkUid !== undefined && requestParameters.xCustominkUid !== null) {
                            headerParameters['X-Customink-Uid'] = String(requestParameters.xCustominkUid);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/analytics/data".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * analytics
     */
    DefaultApi.prototype.apiStoresUrlSlugAnalyticsDataGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugAnalyticsDataGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * products
     */
    DefaultApi.prototype.apiStoresUrlSlugAnalyticsProductsGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugAnalyticsProductsGet.');
                        }
                        queryParameters = {};
                        if (requestParameters.dateStart !== undefined) {
                            queryParameters['date_start'] = requestParameters.dateStart;
                        }
                        if (requestParameters.dateEnd !== undefined) {
                            queryParameters['date_end'] = requestParameters.dateEnd;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (requestParameters.xCustominkUid !== undefined && requestParameters.xCustominkUid !== null) {
                            headerParameters['X-Customink-Uid'] = String(requestParameters.xCustominkUid);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/analytics/products".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * products
     */
    DefaultApi.prototype.apiStoresUrlSlugAnalyticsProductsGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugAnalyticsProductsGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * cancel
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdCancelPutRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdCancelPut.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdCancelPut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/{campaign_id}/cancel".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * cancel
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdCancelPut = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsCampaignIdCancelPutRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * fulfill
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdFulfillPatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdFulfillPatch.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdFulfillPatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/{campaign_id}/fulfill".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * fulfill
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdFulfillPatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsCampaignIdFulfillPatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * campaign
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdGet.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/{campaign_id}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CampaignFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * campaign
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsCampaignIdGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * reopen
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdReopenPutRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdReopenPut.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdReopenPut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/{campaign_id}/reopen".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * reopen
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdReopenPut = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsCampaignIdReopenPutRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * replace
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdReplacePutRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdReplacePut.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsCampaignIdReplacePut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/{campaign_id}/replace".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * replace
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsCampaignIdReplacePut = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsCampaignIdReplacePutRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * confirm
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsConfirmCampaignIdGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsConfirmCampaignIdGet.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsConfirmCampaignIdGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/confirm/{campaign_id}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.CampaignConfirmationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * confirm
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsConfirmCampaignIdGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsConfirmCampaignIdGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * confirm_order
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsConfirmOrderCampaignIdGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugCampaignsConfirmOrderCampaignIdGet.');
                        }
                        if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                            throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling apiStoresUrlSlugCampaignsConfirmOrderCampaignIdGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/campaigns/confirm_order/{campaign_id}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("campaign_id", "}"), encodeURIComponent(String(requestParameters.campaignId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ConfirmOrderFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * confirm_order
     */
    DefaultApi.prototype.apiStoresUrlSlugCampaignsConfirmOrderCampaignIdGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugCampaignsConfirmOrderCampaignIdGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * store
     */
    DefaultApi.prototype.apiStoresUrlSlugGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.StoreFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * store
     */
    DefaultApi.prototype.apiStoresUrlSlugGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * update store
     */
    DefaultApi.prototype.apiStoresUrlSlugPatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugPatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ApiStoresUrlSlugPatchRequestToJSON)(requestParameters.apiStoresUrlSlugPatchRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * update store
     */
    DefaultApi.prototype.apiStoresUrlSlugPatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugPatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * products
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugProductsGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/products".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ProductsInnerFromJSON); })];
                }
            });
        });
    };
    /**
     * products
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugProductsGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * create product
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsPostRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugProductsPost.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/products".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ProductCreateToJSON)(requestParameters.productCreate),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * create product
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsPost = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugProductsPostRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * fetch product
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsProductIdGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugProductsProductIdGet.');
                        }
                        if (requestParameters.productId === null || requestParameters.productId === undefined) {
                            throw new runtime.RequiredError('productId', 'Required parameter requestParameters.productId was null or undefined when calling apiStoresUrlSlugProductsProductIdGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/products/{product_id}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("product_id", "}"), encodeURIComponent(String(requestParameters.productId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ProductFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * fetch product
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsProductIdGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugProductsProductIdGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * update product
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsProductIdPatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugProductsProductIdPatch.');
                        }
                        if (requestParameters.productId === null || requestParameters.productId === undefined) {
                            throw new runtime.RequiredError('productId', 'Required parameter requestParameters.productId was null or undefined when calling apiStoresUrlSlugProductsProductIdPatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/products/{product_id}".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))).replace("{".concat("product_id", "}"), encodeURIComponent(String(requestParameters.productId))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * update product
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsProductIdPatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugProductsProductIdPatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * reorder products
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsReorderPatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugProductsReorderPatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/products/reorder".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ApiStoresUrlSlugProductsReorderPatchRequestToJSON)(requestParameters.apiStoresUrlSlugProductsReorderPatchRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * reorder products
     */
    DefaultApi.prototype.apiStoresUrlSlugProductsReorderPatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugProductsReorderPatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * cancel
     */
    DefaultApi.prototype.apiStoresUrlSlugPurchasesCancelPatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugPurchasesCancelPatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/purchases/cancel".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ApiStoresUrlSlugPurchasesCancelPatchRequestToJSON)(requestParameters.apiStoresUrlSlugPurchasesCancelPatchRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * cancel
     */
    DefaultApi.prototype.apiStoresUrlSlugPurchasesCancelPatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugPurchasesCancelPatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * purchases
     */
    DefaultApi.prototype.apiStoresUrlSlugPurchasesGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugPurchasesGet.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/purchases".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ApiStoresUrlSlugPurchasesGet200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * purchases
     */
    DefaultApi.prototype.apiStoresUrlSlugPurchasesGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugPurchasesGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * update purchase
     */
    DefaultApi.prototype.apiStoresUrlSlugPurchasesUpdatePatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugPurchasesUpdatePatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/purchases/update".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.ApiStoresUrlSlugPurchasesUpdatePatchRequestToJSON)(requestParameters.apiStoresUrlSlugPurchasesUpdatePatchRequest),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * update purchase
     */
    DefaultApi.prototype.apiStoresUrlSlugPurchasesUpdatePatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugPurchasesUpdatePatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * settings
     */
    DefaultApi.prototype.apiStoresUrlSlugSettingsGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugSettingsGet.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/settings".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.StoreSettingsFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * settings
     */
    DefaultApi.prototype.apiStoresUrlSlugSettingsGet = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugSettingsGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * settings
     */
    DefaultApi.prototype.apiStoresUrlSlugSettingsPutRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.urlSlug === null || requestParameters.urlSlug === undefined) {
                            throw new runtime.RequiredError('urlSlug', 'Required parameter requestParameters.urlSlug was null or undefined when calling apiStoresUrlSlugSettingsPut.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/api/stores/{url_slug}/settings".replace("{".concat("url_slug", "}"), encodeURIComponent(String(requestParameters.urlSlug))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, models_1.StoreSettingsToJSON)(requestParameters.storeSettings),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * settings
     */
    DefaultApi.prototype.apiStoresUrlSlugSettingsPut = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiStoresUrlSlugSettingsPutRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * logged-in user details
     */
    DefaultApi.prototype.apiUsersCurrentUserGetRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.storeId !== undefined) {
                            queryParameters['store_id'] = requestParameters.storeId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/api/users/current_user",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ApiUsersCurrentUserGet200ResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * logged-in user details
     */
    DefaultApi.prototype.apiUsersCurrentUserGet = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiUsersCurrentUserGetRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DefaultApi;
}(runtime.BaseAPI));
exports.DefaultApi = DefaultApi;
